import { Component, HostListener, Inject, OnInit } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { ToolsService } from 'src/app/services/tools/tools.service';
import { ProdComponent } from '../prod/prod.component';
import { FulleStockService } from 'src/app/services/api/fulle/fulle-stock/fulle-stock.service';
import { PanierService } from 'src/app/services/manage/panier/panier.service';
import { ProdcatService } from 'src/app/services/api/prodcat/prodcat.service';
import { TranslateService } from '@ngx-translate/core';
import { ProductService } from 'src/app/services/api/product/product.service';
import { cloneDeep } from 'lodash';


@Component({
  selector: 'app-formules-suggestions',
  templateUrl: './formules-suggestions.component.html',
  styleUrls: ['./formules-suggestions.component.css']
})
export class FormulesSuggestionsComponent implements OnInit {
  merchantClient$: any;
  suggestionFormules: any;
  innerHeight: number = window.innerHeight;

  pointOfsale: any;
  default_prod: string = "https://748073e22e8db794416a-cc51ef6b37841580002827d4d94d19b6.ssl.cf3.rackcdn.com/not-found.png";

  prodselected: any;
  buttonScroll: any;
  loaderpop: boolean = false;
  statusMessage: any = null;

  categories: any;
  copyProdselected: any;
  maxlengthFormule = 6;
  height: any;
  price_supp = 0;

  constructor(
    @Inject(MAT_DIALOG_DATA) data: any,
    public dialogRef: MatDialogRef<FormulesSuggestionsComponent>,
    private tools: ToolsService,
    public media: MediaObserver,
    public dialog: MatDialog,
    private panierMan: PanierService,
    private stockApi: FulleStockService,
    private prodcatApi: ProdcatService,
    public translate: TranslateService,
    public ProductService: ProductService
  ) {


    this.suggestionFormules = data.suggestionFormules.sort(() => Math.random() - 0.5);
    this.merchantClient$ = data.merchantClient;
    this.pointOfsale = this.tools.getStor("point_of_sale");
    this.prodselected = data.prodselected;
    this.categories = data.categories ? data.categories : null;
   
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.innerHeight = window.innerHeight;
    this.buttonVisibleScroll();

  }
  ngOnInit(): void {
    this.innerHeight = window.innerHeight;
    this.setDetails();
    // set button scroll  
    this.buttonVisibleScroll();

  }


  /**
  * @description   set Details  to product
      
  */

  setDetails() {

    /**
       * Si le produit est de type produit avec option ou de type formule
   * alors on implémente les détails et les catégories
   */
    const details: any = []; // Les détails du produit
    if (this.prodselected.product_type > 0) {
      this.categories.map((cat: any) => {
        cat.details.map((det: any) => {
          if (det.product.quantity > 0) {
            details.push(det.product);
          }
        });
      });

    }

    this.prodselected.categories = this.categories;
    this.prodselected.details = details;
    this.copyProdselected = cloneDeep(this.prodselected);

    //set price a 0 to formule
    this.prodselected.price = 0;

  }




  /**
     * @description buttonVisibleScroll
       */
  buttonVisibleScroll() {
    //calcul button for scroll
    setTimeout(() => {
      let popupCont = document.getElementById('#popupCont');
      let title = document.getElementById('title');
      let buttonB = document.getElementById('buttonB');
      if (popupCont && title && buttonB) {
        this.buttonScroll = popupCont.getBoundingClientRect().bottom > this.innerHeight -
          title.clientHeight - buttonB.clientHeight ? true : false;


        this.height = this.innerHeight - title.clientHeight - buttonB.clientHeight;


      }

    }, 0);
  }

  /**
    * @description   scroll
    
    */
  scroll() {
    setTimeout(() => {
      let index = this.suggestionFormules.length >= this.maxlengthFormule ? this.maxlengthFormule - 1 : this.suggestionFormules.length - 1;

      const elmnt2 = document.getElementById("id_" + index);

      if (elmnt2) {
        elmnt2.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
      }


    }, 0);
  }


  /**
   * @description openDial check categories
   * @params prod
   */
  openProdDial(prod: any) {

    this.getcatProd(prod);

  }



  /**
    * @description get categories Prod
    * @params prod
    */

  getcatProd(prod: any) {

    this.loaderpop = true;
    this.statusMessage = this.translate.instant('loaderCats');
    this.prodcatApi.getApiProdCatsByIdProd(prod).subscribe((cats) => {

      cats = this.checkCategories(cats);

      cats.map((cat: any) => {
        this.prodselected.details.map((prodDet: any) => {
          if (prodDet.cat === cat.id) {
            cat.details.push(prodDet);
          }
        });
      });


      prod.categories = cats;

      prod.price = prod.prices[0].price;

      prod.novisible = prod.categories && prod.categories.length > 0 ? false : true;
      prod.details = [this.getPricedetailsProduct(prod)];
      this.loaderpop = false;
      this.statusMessage = null;



      this.openDialProdComp(prod, cats);
    });

  }

  /**
   * @description checkCategories
   * @params cats
   */
  checkCategories(cats: any) {



    let newCats: any = [];
    if (cats && cats.length > 0) {
      let $arrayCatdany: any = [];
      cats.forEach((element: any) => {


        let detailsCats: any = []
        if (element && element.details && element.details.length > 0) {
          element.details.forEach((details: any) => {
            if (details.product && details.product.product_type < 2) {
              if (this.prodselected.id == details.product.id && !$arrayCatdany["id_" + this.prodselected]) {
                this.prodselected.cat = element.id;
                $arrayCatdany["id_" + this.prodselected] = element.id;
              }

              detailsCats.push(details);
            }
          });
          if (detailsCats && detailsCats.length > 0) {
            element.details = detailsCats;
            newCats.push(element);
          }
        }
      });
    }

    return newCats;


  }

  /**
    * @description openDial Prod Composant
    * @params prod
    * @params ?categories
    */

  openDialProdComp(prod: any, categories?: any): void {

    this.ProductService.setObserLoaderFormulePSuggested(false);

    //  this.ProductService.setObserProductTypeformule(prod.product_type == 2?true:false);
    const myConf = new MatDialogConfig();
    if (this.media.isActive('xs')) {
      myConf.panelClass = 'full-screen';
    } else {
      myConf.width = prod.product_type === 2 ? "780px" : "450px";
      myConf.maxHeight = '700px';
    }
    myConf.autoFocus = false;

    myConf.data = {
      from: 'update',
      prod: prod,
      FormuleSuggested: true,
      merchantClient: this.merchantClient$ ? this.merchantClient$ : null,
      categories: categories,
      FormuleProdselected_id: this.prodselected.id
      // FormuleProdselected_cat_id: this.prodselected.
    };



    const myDial = this.dialog.open(ProdComponent, myConf);
    myDial.afterClosed().subscribe((result) => {

      if (result) {
        this.closeDial("add");
      }

    })
  }





  /**
 * @description set product original
 */
  setProductOriginal() {



    //stocks

    if (this.copyProdselected.stock && this.copyProdselected.stock.count && this.copyProdselected.stock.count > 0) {
      this.copyProdselected.stock.count -= this.copyProdselected.quantity;
      this.stockApi.stocks[this.copyProdselected.id.toString()].count = this.copyProdselected.stock.count;
    }

    // add to basket
    this.panierMan.manageProduct(this.copyProdselected, this.stockApi.stocks);

    //change stok in view
    if (this.copyProdselected.stock) {
      this.stockApi.setCurrStock(this.prodselected.id, this.copyProdselected.stock.count);
    }


    this.closeDial();
  }

  /**
 * @description closeDial
 */

  closeDial(data?: any) {
    this.dialogRef.close(data);
  }


  /**
* @description get price
* @params prod
*/
  getPrice(prod: any, cat?: any) {




    this.price_supp = 0;
    let $arrayProdany: any = [];
    if (prod.categories && prod.categories.length > 0) {
      prod.categories.forEach((element: any) => {
        if (element.details && element.details.length > 0) {
          for (let index = 0; index < element.details.length; index++) {
            const elemen = element.details[index];

            if (elemen.product.id == this.prodselected.id && !$arrayProdany["id_" + this.prodselected.id]) {
              this.price_supp = elemen.price;
              $arrayProdany["id_" + this.prodselected.id] = this.prodselected.id;
              break;
            }
          }

        }
      });

    }


    if (this.prodselected.prices[0].price <= (prod.prices[0].price + this.price_supp)) {

      return prod.prices[0].price - this.prodselected.prices[0].price + this.price_supp;
    }
    else {

      return prod.prices[0].price + this.price_supp;
    }




  }


  /**
* @description get price details
* @params prod
*/
  getPricedetailsProduct(prod: any) {

    let $arrayProdany: any = [];
    if (prod.categories && prod.categories.length > 0) {
      prod.categories.forEach((element: any) => {
        if (element.details && element.details.length > 0) {
          for (let index = 0; index < element.details.length; index++) {
            const elemen = element.details[index];

            if (elemen.product.id == this.prodselected.id && !$arrayProdany["id_" + this.prodselected.id]) {
              this.prodselected.price = elemen.price;
              $arrayProdany["id_" + this.prodselected.id] = this.prodselected.id;
              break;
            }
          }

        }
      });

    }
    return this.prodselected;

  }
}
